module.exports = __webpack_public_path__ + "static/01-17664132e592cfc6a7523ceadb4e1247.jpg";